import React from 'react';

import styles from '../../containers/TaxWithholding/TaxWithholding.module.scss';
import {
  SPECIAL_STATES,
  DC_STATE_CODE,
  STATE_TYPE,
  FEDERAL_STATES,
  SPECIAL_DISTRIBUTION_STATES,
  SPECIAL_STATE_TAX,
} from '../../settings/settings';
import iconQuestionmark from '../../../src/assets/images/icon-questionmark.svg';

function TaxWithholdingNotes({
  withHoldingState,
  declineWithHolding,
  electWithHoldingTaxNote,
  percentage,
  mandatory,
  handleClick,
  multiState,
  stateList,
}) {
  let stateCode;
  let stateName;
  if (withHoldingState) {
    stateCode = withHoldingState.stateCode;
    stateName = withHoldingState.stateName;
  }
  const multipleStateType =
    stateList && stateList.length === 1
      ? STATE_TYPE.MANDATORY
      : stateList && stateList.length > 1
      ? STATE_TYPE.MULTI_STATE
      : '';

  const isMinnesota = SPECIAL_STATE_TAX.indexOf(stateCode) > -1;
  const isSpecialState = SPECIAL_STATES.indexOf(stateCode) > -1;
  const isFederalState = FEDERAL_STATES.indexOf(stateCode) > -1;
  const isSpecialDistributionState =
    SPECIAL_DISTRIBUTION_STATES.indexOf(stateCode) > -1;

  const QuestionMark = ({ handleClick }) => (
    <span className="icon-questionmark">
      <img src={iconQuestionmark} alt="" onClick={handleClick} />
    </span>
  );
  if (multiState && mandatory) {
    return (
      <span className={styles['tax-notes']}>
        There are multiple states associated with your investments. State taxes
        will be withheld accordingly.
        <QuestionMark handleClick={() => handleClick(multipleStateType)} />
      </span>
    );
  } else if (multiState && !mandatory) {
    return (
      <span className={styles['tax-notes']}>
        State income tax withholding for the states associated with your
        investments is not available.
      </span>
    );
  } else if (!mandatory) {
    return (
      <span className={styles['tax-notes']}>
        State income tax withholding for&nbsp;
        <strong>{stateName}</strong>&nbsp;will not be applied.
      </span>
    );
  } else if (isSpecialState || isMinnesota) {
    switch (stateCode) {
      case DC_STATE_CODE:
        return (
          <span className={styles['tax-notes']}>
            State income tax withholding for&nbsp;
            <strong>
              {stateName} ({percentage}% of the distribution)
            </strong>
            &nbsp;is only applied when taking a total distribution.
            <QuestionMark
              handleClick={() => handleClick(STATE_TYPE.DC_SPECIAL_STATE)}
            />
          </span>
        );
      case 'MN':
        return (
          <span className={styles['tax-notes']}>
            State income tax withholding for&nbsp;
            <strong>
              {stateName} ({percentage}% of the distribution)
            </strong>
            &nbsp;will be applied.
            <QuestionMark
              handleClick={() => handleClick(STATE_TYPE.SPECIAL_STATE_TAX)}
            />
          </span>
        );
      default:
        return (
          <span className={styles['tax-notes']}>
            State income tax withholding for&nbsp;
            <strong>
              {stateName} ({percentage}% of the distribution)
            </strong>
            &nbsp;will{' '}
            <span className="orphan-line">
              be applied.
              <QuestionMark
                handleClick={() => handleClick(STATE_TYPE.SPECIAL_STATES)}
              />
            </span>
          </span>
        );
    }
  } else if (electWithHoldingTaxNote && isFederalState) {
      return (
      <span className={styles['tax-notes']}>
        State income tax withholding for&nbsp;
        <strong>
         {stateName} ({percentage}% of federal withholding)
        </strong>
        &nbsp;will <span className="orphan-line">be applied.</span>
        <QuestionMark handleClick={() => handleClick(STATE_TYPE.MANDATORY)} />
      </span>
    );
  } else if (electWithHoldingTaxNote && isSpecialDistributionState) {
    return (
      <span className={styles['tax-notes']}>
        State income tax withholding for&nbsp;
        <strong>
        <>{stateName} ({percentage}% of the distribution)</>
        </strong>
        &nbsp;will <span className="orphan-line">be applied.</span>
        <QuestionMark handleClick={() => handleClick(STATE_TYPE.MANDATORY)} />
      </span>
    );
  } else if (electWithHoldingTaxNote) {
    return (
      <span className={styles['tax-notes']}>
        State income tax withholding for&nbsp;
        <strong>
          {stateName} ({percentage}% of the distribution)
        </strong>
        &nbsp;will <span className="orphan-line">be applied.</span>
        <QuestionMark handleClick={() => handleClick(STATE_TYPE.MANDATORY)} />
      </span>
    );
  } else if (declineWithHolding) {
    return (
      <span className={styles['tax-notes']}>
        State income tax withholding for&nbsp;
        <strong>{withHoldingState.stateName}</strong>&nbsp;is declined.
        <QuestionMark handleClick={() => handleClick(STATE_TYPE.MANDATORY)} />
      </span>
    );
  } else {
    return '';
  }
}

export default TaxWithholdingNotes;
